module.exports = __webpack_public_path__ + "static/media/ios-location-settings.fbdfba4a.jpg";